import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store/index.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  const isAuthenticated = store.getters['authOidc/isAuthenticated']
  const userRole = store.getters['authOidc/userRole']
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const allowedRoles = to.meta.roles || []

  if (requiresAuth) {
    const hasAccess = userRole != null ? allowedRoles.some((role) => userRole.includes(role)) : false
    const loginPath = to.matched.find(record => record.meta.loginPath)?.meta.loginPath || '/login'

    if (!isAuthenticated) {
      next({ path: loginPath })
    } else if (!hasAccess) {
      next({ path: '/access-denied' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router